var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.data.length < 1,
            expression: "data.length < 1",
          },
        ],
        staticClass: "step",
      },
      _vm._l(_vm.data, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "child",
            style:
              "width:" +
              100 / _vm.data.length +
              "%;color:" +
              (_vm.active == index
                ? "#409eff"
                : _vm.active < index
                ? "rgb(200, 200, 200)"
                : "#67c23a"),
          },
          [
            index + 1 != _vm.data.length
              ? _c("div", {
                  staticClass: "line",
                  style:
                    "background:" +
                    (_vm.active <= index ? "#c0c4cc" : "#67c23a"),
                })
              : _vm._e(),
            _vm._m(0, true),
            _c("div", { staticClass: "text" }, [
              _vm._v("审批节点：" + _vm._s(item.displayName)),
            ]),
            _c("div", { staticClass: "underline" }),
            item.operatorName
              ? _c("div", { staticClass: "text" }, [
                  _vm._v(
                    _vm._s(
                      (index == 0 ? "发起人：" : "审批人：") + item.operatorName
                    )
                  ),
                ])
              : _vm._e(),
            item.operatorName
              ? _c("div", { staticClass: "underline" })
              : _vm._e(),
            item.finishTime
              ? _c("div", { staticClass: "text" }, [
                  _vm._v(
                    _vm._s(
                      (index == 0 ? "发起时间：" : "审批时间：") +
                        item.finishTime
                    )
                  ),
                ])
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "el-icon-s-custom" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }